export default __webpack_public_path__ + "static/media/50.c2f97fd2.jpg";